module.exports = __webpack_public_path__ + "img/mainFunction-icon5.7de620f9.png";